<template>
	<div class="col">
		<div class="row">
			<div class="col-sm-9 full-height">
				<div class="comparisonChart full-height lcpCard">
					<highcharts class="chartWrapper" :options="chartObject" />
				</div>
			</div>
			<div class="col-sm-3">
				<comparison-sidebar />
			</div>
		</div>
	</div>
</template>

<script>
import { Chart } from 'highcharts-vue';
import comparisonSidebar from '@/components/common/uiLayouts/comparisonSidebar.vue';

export default {
    components: {
        comparisonSidebar,
        highcharts: Chart,
    },
    data () {
        return {
            chartOptions: {
                chart: {},
                xAxis: {
                    title: { text: '' },
                    labels: {},
                },
                yAxis: [{ title: { text: '' }, labels: {} }],
                tooltip: {
                    enabled: true,
                    formatter: null,
                },
                plotOptions: {
                    histogram: {},
                },
            },
            seriesData: [],
        };
    },
    created () {
        this.chartOptions.xAxis.type = 'datetime';
        this.chartOptions.tooltip.formatter = function () {
            if (this.hasOwnProperty('points')) {
                return (
                    `<table>${
					 this.points.reduce((s, point) => `${s}<span style="color:${point.series.color}; font-weight: bold">${point.series.name}</span> &nbsp;${Math.round(point.y * 10) / 10}%<br/>`, '<tr><td><b></table>')}`
                );
            }
        };
        this.chartOptions.xAxis.utc = true;
        this.chartOptions.xAxis.title.text = 'Length of track record';
        this.chartOptions.yAxis[0].title.text = 'Return %';
    },
    computed: {
        managerData () {
            return this.$store.getters.getUnDeletedSelectedMangers;
        },
        chartObject () {
            const options = this.chartOptions;
            const startDate = this.$moment(this.$store.state.ui.minimumDate);
            const lenRet = this.managerData[0].dailyData.length;
            const points = Math.max(Math.min(Math.floor(lenRet / 100.0), 7), 1);
            const result = [];

            for (let d = 0; d < this.managerData.length; d += 1) {
                var data = [];
                this.managerData[d].dailyData.forEach((d, i) => {
                    if (i === 0 || i === lenRet - 1 || i % points === 0) {
                        data.push([
                            this.$moment(startDate)
                                .add(i, 'd')
                                .valueOf(),
                            (d - 1) * 100,
                        ]);
                    }
                });

                result.push({
                    name: this.$store.state.universe.data.keyData[this.managerData[d].ticker].name,
                    color: this.managerData[d].color,
                    data,
                });
            }
            options.series = result;
            return options;
        },
    },
};
</script>

<style lang="scss">
.comparisonChart {
	height: 80vh;
	#performanceChart {
		padding: 20px;
		.axis line {
			fill: none;
			stroke: #000;
			shape-rendering: crispEdges;
		}
		.x.axis path {
			display: none;
		}
		.line {
			fill: none;
			stroke: steelblue;
			stroke-width: 2px;
		}
	}
}
</style>
